export default __webpack_public_path__ + "static/foxi-pro-a3d958ac480dabe52bf3b6e949fef73a.jpg";